import React from 'react'
import { FormControl, InputBase, InputLabel, MenuItem, Select, withStyles } from '@material-ui/core'


const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      // marginTop: theme.spacing(3),
      position: 'relative'
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

export const CustomSelect = (props) => {
  const { label="", value, name, onChange, options=[], error='', small=false, formStyle } = props
  return (
    <FormControl variant="outlined" fullWidth error={error.length === 0 ? false : true} style={formStyle}>
    <InputLabel id="demo-simple-select-filled-label" style={{
      backgroundColor: 'white', padding: '1px 15px', borderRadius: 4
    }}>{label}</InputLabel>
    {
      !small 
      ? 
      <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={value}
          onChange={onChange}
          variant="outlined"
          { ...props }
        >
          <MenuItem value="">
            <em>...</em>
          </MenuItem>
            {
              options.map(opt => (
                <MenuItem value={opt.value} key={opt.value}>{opt.label}</MenuItem>
              ))
            }
        </Select>

      : 
      <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={value}
          onChange={onChange}
          input={<BootstrapInput />}
          inputProps={{ name: name }}
          { ...props }
        >

          <MenuItem aria-label="None" value="">
            ...
          </MenuItem>
          {
              options.map(opt => (
                <MenuItem value={opt.value} key={opt.value}>{opt.label}</MenuItem>
              ))
            }
        </Select>
    }
  </FormControl>
  )
}
